import { CurrencyPipe, NgFor, NgIf } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { PublicCatalogItem } from 'src/app/models/catalogs/public-catalog';
import { PublicCatalogService } from 'src/app/services/public-catalog.service';
import { environment } from 'src/environments/environment';
import { A11yModule } from "@angular/cdk/a11y";

@Component({
  selector: 'app-available-services',
  imports: [NgFor, NgIf, CurrencyPipe, A11yModule],
  templateUrl: './available-services.component.html',
  styleUrl: './available-services.component.css'
})
export class AvailableServicesComponent implements OnInit {
  private readonly catalogService = inject(PublicCatalogService);
  public _router = inject(Router);
  items: PublicCatalogItem[] = [];
  loading = false;
  fileBaseUrl = `${environment.api.url}/File/ViewFile`;

  ngOnInit(): void {
    this.loadServices();
  }

  private loadServices(): void {
    this.loading = true;
    this.catalogService.getPublicCatalog(1, 20, undefined, 1).subscribe({
      next: res => {
        this.items = res.items || [];
        this.loading = false;
      },
      error: _ => {
        this.loading = false;
      }
    });
  }

  navigateDetail(item: any) {

    this._router.navigate(['home/available-services-detail', item.id]);
  }
}